import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials, initialTestimonials, moreTestimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosGrid } from './components/TomosGrid';
import { IncludesChecklist } from './components/IncludesChecklist';
import { BonosSection } from './components/BonosSection';
import { CountdownUrgency } from './components/CountdownUrgency';
import { Pricing } from './components/Pricing';
import { ProfessionalComparison } from './components/ProfessionalComparison';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-amber-200 selection:text-slate-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <SocialProof data-id="element-3" />
        <Testimonials testimonials={initialTestimonials} data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <TomosGrid data-id="element-6" />
        <IncludesChecklist data-id="element-7" />
        <BonosSection data-id="element-8" />
        <CountdownUrgency data-id="element-9" />
        <Pricing data-id="element-10" />
        <ProfessionalComparison data-id="element-11" />
        <Testimonials testimonials={moreTestimonials} title="❤️ MÁS PERSONAS QUE YA LO TIENEN" className="bg-white" data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQ data-id="element-14" />
        <CostComparison data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <PurchaseNotification data-id="element-18" />
    </div>;
}